import { useAiApiHeaders } from '~/composables/useAiApiHeaders';

const BASE_PATH = '/api/v1/tenant/assistant';

export const AI_ENDPOINTS = {
    prompt: `${BASE_PATH}/prompt`,
    conversations: `${BASE_PATH}/conversations`,
    conversationMessages: (id: string) => `${BASE_PATH}/conversations/${id}/messages`,
    conversationEntities: (id: string) => `${BASE_PATH}/conversations/${id}/entities`,
    forDocument: `${BASE_PATH}/conversations/for-document`,
} as const;

export const useAiEndpoints = () => {
    const { getHeaders, baseUrl } = useAiApiHeaders();

    const url = (path: string): string => `${baseUrl}${path}`;

    const jsonHeaders = (): Record<string, string> => ({
        ...getHeaders(),
        'Content-Type': 'application/json',
    });

    return { url, getHeaders, jsonHeaders, baseUrl };
};
